import React, { useRef, useCallback, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { AiOutlineFile } from "react-icons/ai"; // Importar ícono para 'Paginas'
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import "./sidebar.scss";
import UsersForm from '../Users/UsersForm';

const Sidebar = ({ user }) => {
  const refSidebar = useRef(null);
  const refLockIcon = useRef(null);
  const refClose = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const navigate = useNavigate(); // Ya lo tenés importado

const refSubOfertasIcon = useRef(null);
const refSubOfertasItems = useRef(null);

  const location = useLocation();  // Hook para obtener la ruta actual

const toggleSubMenu = (iconRef, itemsRef) => {
  if (iconRef.current && itemsRef.current) {
    iconRef.current.classList.toggle('bx-rotate-90');
    itemsRef.current.classList.toggle('hidden');
  }
};


const isActive = (path) => {
  return location.pathname === path;
};


  const toggleLock = useCallback(() => {
    if (refSidebar.current && refLockIcon.current) {
      refSidebar.current.classList.toggle("locked");

      if (!refSidebar.current.classList.contains('locked')) {
        refSidebar.current.classList.add('hoverable');
        refLockIcon.current.classList.replace('bx-lock-alt', 'bx-lock-open-alt');
      } else {
        refSidebar.current.classList.remove('hoverable');
        refLockIcon.current.classList.replace('bx-lock-open-alt', 'bx-lock-alt');
      }
    }
  }, []);

  const hideSidebar = useCallback(() => {
    if (refSidebar.current && refSidebar.current.classList.contains('hoverable')) {
      refSidebar.current.classList.add('close');
    }
  }, []);

  const showSidebar = useCallback(() => {
    if (refSidebar.current && refSidebar.current.classList.contains('hoverable')) {
      refSidebar.current.classList.remove('close');
    }
  }, []);

  const logout = useCallback(() => {
    axios.post(process.env.REACT_APP_URL_API + 'logout', {}, {
      withCredentials: true
    }).then(response => {
      // Manejar el logout exitoso
      navigate('/login'); // o cualquier ruta que quieras

    }).catch(error => {
      console.error('Logout error:', error);
    });
  }, []);

  const handleProfileClick = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_URL_API + 'profile', {
        withCredentials: true
      });

      setSelectedUser(response.data);
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error fetching user profile:', error);
      alert('Failed to fetch profile. Please try again.');
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const hasPermission = useCallback((tag) => {
    if (user && user.permissions) {
      const isViewer = user.permissions.some(permission => permission.tag === 'VIEWER');
      if (isViewer) {
        return user.permissions.some(permission => permission.tag === tag || permission.tag === 'VIEWER');
      }
      const isSuperAdmin = user.permissions.some(permission => permission.tag === 'SUPERADMIN');
      if (isSuperAdmin) {
        return true;
      }
      return user.permissions.some(permission => permission.tag === tag);
    }
    return false; // No se encontraron permisos
  }, [user]);

  if (!user) {
    return null; // No se muestra nada si el usuario no está definido
  }

  const getLinkClassName = (path) => {
    return location.pathname.includes(path) ? 'link flex active' : 'link flex';
  }

  return (
    <>
      <nav ref={refSidebar} className="sidebar locked" onMouseLeave={hideSidebar} onMouseEnter={showSidebar}>
        <div className="logo_items flex">
          <span className="nav_image"></span>
          <span className="logo_name">Untref Virtual</span>

          <i ref={refLockIcon} className='bx bx-lock-alt' id="lock-icon" title="Unlock sidebar" onClick={toggleLock}></i>
          <i ref={refClose} className='bx bx-x' id="sidebar-close"></i>
        </div>

        <div className="menu_container">
          <div className="menu_items">
            <ul className="menu_item">
              <div className="menu_title flex">
                <span className="title">Dashboard</span>
                <span className="line"></span>
              </div>


            {/* Opción 'Menu' */}
            {hasPermission('CORE_USERS') && (
              <li className="item">
                <Link to="/admin/menu" style={{ textDecoration: "none" }}>
                  <p
                    className={getLinkClassName('/admin/menu')}
                    style={
                      location.pathname.includes('/admin/menu')
                        ? { backgroundColor: 'rgba(255, 255, 255, 0.4156862745)' }
                        : {}
                    }
                    onClick={() => console.log('Link to Menu clicked!')}
                  >
                    <i className='bx bx-menu'></i>
                    <span>Menu</span>
                  </p>
                </Link>
              </li>
            )}

              {/* Opción 'Paginas' añadida aquí */}
              {hasPermission('CORE_USERS') && (
                <li className="item">
                  <Link to="/admin/paginas" style={{ textDecoration: "none" }}>
                    <p className={getLinkClassName('/admin/paginas')} style={location.pathname.includes('/admin/paginas') ? { backgroundColor: 'rgba(255, 255, 255, 0.4156862745)' } : {}} onClick={() => console.log('Link to Paginas clicked!')}>
                      <i className='bx bx-user'></i>
                      <span>Paginas</span>
                    </p>
                  </Link>
                </li>
              )}



          <li className="item">
            <p className="link flex" onClick={() => toggleSubMenu(refSubOfertasIcon, refSubOfertasItems)}>
              <i className="bx bx-book-reader"></i>
              <span>Ofertas Académicas</span>
              <i ref={refSubOfertasIcon} className="ml-auto bx bx-chevron-right"></i>
            </p>
            <ul className="sub_menu_item hidden" ref={refSubOfertasItems}>
              <Link to="/admin/ofertas/carreras" style={{ textDecoration: "none" }}>
                <li className={`item ${isActive("/admin/ofertas/carreras") ? "active" : ""}`}>
                  <p className="link flex">
                    <i className="bx bx-book"></i>
                    <span>Carreras</span>
                  </p>
                </li>
              </Link>

              <Link to="/admin/ofertas/mediosdepago" style={{ textDecoration: "none" }}>
                <li className={`item ${isActive("/admin/ofertas/mediosdepago") ? "active" : ""}`}>
                  <p className="link flex">
                    <i className="bx bx-credit-card"></i>
                    <span>Medios de Pago</span>
                  </p>
                </li>
              </Link>
            </ul>
          </li>



              {/* Opción 'Convenios' añadida aquí */}
              {hasPermission('CORE_USERS') && (
                <li className="item">
                  <Link to="/admin/convenios" style={{ textDecoration: "none" }}>
                    <p className={getLinkClassName('/admin/convenios')} style={location.pathname.includes('/admin/convenios') ? { backgroundColor: 'rgba(255, 255, 255, 0.4156862745)' } : {}} onClick={() => console.log('Link to Convenios clicked!')}>
                      <i className='bx bxs-file-doc'></i>
                      <span>Convenios</span>
                    </p>
                  </Link>
                </li>
              )}

              {/* Opción 'Docentes' añadida aquí */}
              {hasPermission('CORE_USERS') && (
                <li className="item">
                  <Link to="/admin/docentes" style={{ textDecoration: "none" }}>
                    <p className={getLinkClassName('/admin/docentes')} style={location.pathname.includes('/admin/docentes') ? { backgroundColor: 'rgba(255, 255, 255, 0.4156862745)' } : {}} onClick={() => console.log('Link to Docentes clicked!')}>
                      <i className='bx bxs-book'></i>
                      <span>Docentes</span>
                    </p>
                  </Link>
                </li>
              )}

              {/* Opción 'Novedades' añadida aquí */}
              <li className="item">
                <Link to="/admin/novedades" style={{ textDecoration: "none" }}>
                  <p className={getLinkClassName('/admin/novedades')} style={location.pathname.includes('/admin/novedades') ? { backgroundColor: 'rgba(255, 255, 255, 0.4156862745)' } : {}} onClick={() => console.log('Link to Novedades clicked!')}>
                    <i className='bx bx-news'></i>
                    <span>Novedades</span>
                  </p>
                </Link>
              </li>

              {/* Opción 'Archivos' añadida aquí */}
              <li className="item">
                <Link to="/admin/archivos" style={{ textDecoration: "none" }}>
                  <p className={getLinkClassName('/admin/archivos')} style={location.pathname.includes('/admin/archivos') ? { backgroundColor: 'rgba(255, 255, 255, 0.4156862745)' } : {}} onClick={() => console.log('Link to Archivos clicked!')}>
                    <i className='bx bx-news'></i>
                    <span>Archivos</span>
                  </p>
                </Link>
              </li>
            </ul>
          </div>
          <div className="bottom-content">




            
            <Link to="/admin/login" style={{ textDecoration: "none" }} onClick={logout}>
              <li className="item">
                <p className="link flex">
                  <i className='bx bx-log-out icon'></i>
                  <span>Logout</span>
                </p>
              </li>
            </Link>

            
          </div>
        </div>
      </nav>

      {/* Modal usando Material-UI */}
      <Dialog open={isModalOpen} onClose={closeModal}>
        <DialogTitle>Profile</DialogTitle>
        <DialogContent>
          <UsersForm 
            user={selectedUser} 
            onSave={closeModal}   
            onCancel={closeModal}
            modal={true}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Sidebar;
